import { Button, Label } from "@enpowered/ui";
import PropTypes from "prop-types";
import React from "react";

const MalformedBillModal = ({ onFail, onCancel }) => {
  return (
    <div>
      <Label className="mb-8">
        Are you sure you wish to flag this file as failed?
      </Label>
      <div className="flex justify-end mt-2">
        <Button
          size="narrow"
          theme="none"
          className="mr-4 bg-white border border-en-gray-300"
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          size="narrow"
          theme="none"
          className="bg-en-red text-white"
          onClick={onFail}
        >
          Fail it
        </Button>
      </div>
    </div>
  );
};

MalformedBillModal.propTypes = {
  onFail: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

export default MalformedBillModal;
